



























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class BaseSelect extends Vue {
  @Prop({ type: String, default: "" }) id!: string;
  @Prop({ type: Array, required: true }) options!: any[];
  @Prop({ default: "" }) value!: any;
  @Prop({ type: String, default: "" }) cssClass!: string;
  @Prop({ type: String, default: "" }) minWidth!: string;
  @Prop({ type: String, default: "" }) maxWidth!: string;
  @Prop({ type: Boolean, default: false }) fullWidth!: boolean;
  @Prop({ type: String, default: "" }) placeholder!: string;

  isOpen: boolean = false;

  get wrapperStyle() {
    const style: any = {};
    if (this.minWidth !== "") {
      style.minWidth = this.minWidth;
    }
    if (this.maxWidth !== "") {
      style.maxWidth = this.maxWidth;
    }
    if (this.fullWidth) {
      style.width = "100%";
      style.maxWidth = "none";
    }
    return style;
  }

  get selectedOption() {
    const items = Array.isArray(this.options) ? this.options : [];
    const current =
      this.value !== null && this.value !== undefined ? String(this.value) : "";
    for (const option of items) {
      if (option && String(option.value) === current) {
        return option;
      }
    }
    return null;
  }

  get fallbackOption() {
    const items = Array.isArray(this.options) ? this.options : [];
    for (const option of items) {
      if (option && option.selected) {
        return option;
      }
    }
    return items.length > 0 ? items[0] : null;
  }

  get displayOption() {
    return this.selectedOption || this.fallbackOption;
  }

  get selectedLabel() {
    if (this.displayOption) {
      return this.getOptionLabel(this.displayOption);
    }
    return this.placeholder;
  }

  get selectedAvatar() {
    if (this.displayOption && this.displayOption.avatar) {
      return this.displayOption.avatar;
    }
    return "";
  }

  closeMenu() {
    this.isOpen = false;
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;
  }

  handleNativeChange(event: Event) {
    const target = event.target as HTMLSelectElement | null;
    const value = target ? target.value : "";
    this.emitValue(value);
  }

  selectOption(option: any) {
    const value = option && option.value !== undefined ? option.value : "";
    this.isOpen = false;
    this.emitValue(value);
  }

  emitValue(value: any) {
    this.$emit("input", value);
    this.$emit("change", value);
  }

  getOptionLabel(option: any) {
    if (option && option.label !== undefined && option.label !== null) {
      return option.label;
    }
    if (option && option.value !== undefined && option.value !== null) {
      return String(option.value);
    }
    return "";
  }
}
